import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDrop = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 11 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.35 3.8V1.32H2.87V.39h5.9v.93H6.27V3.8h-.93Zm-4.5 7.75v-4.8h.94v.61H4.1V5.2H3.5v-.93h4.65v.93h-.62v2.17h2.33v-.62h.93v4.81h-.93v-.62H1.79v.62H.86ZM1.8 10h8.06V8.3H6.59V5.2H5.04v3.1H1.8V10Z" })
});
export default SvgDrop;
